<template>
  <el-drawer title="系统通知" :visible.sync="drawer" destroy-on-close :wrapperClosable="false" custom-class="widthCommon">
    <template #title>
      <div>
        系统通知
        <span style="margin-left: 20px; color: #31a8ff; font-size: 14px">物业帮帮将为您保存7天的系统通知</span>
      </div>
    </template>
    <div style="display: flex; align-items: center; justify-content: space-between">
      <el-tabs v-model="readState" @tab-click="handleClick">
        <el-tab-pane :label="`未读 ${unreadCount}`" name="1" />
        <el-tab-pane :label="`已读 ${readCount}`" name="2" />
      </el-tabs>

      <div class="readBox" :class="{ readBoxHui: readState == 2 }" @click="clearUnRead">全部已读</div>
    </div>
    <el-card>
      <div v-if="!show" v-infinite-scroll="loadMore">
        <div class="notice" :class="{ unread: item.readState === 1 }" v-for="item in totalData" :key="item.id" @click="goDetail(item)">
          <template v-if="item.messageContent">
            <div class="top">
              <span>{{ item.messageContent }}</span>
              <i class="el-icon-arrow-right" style="float: right" />
            </div>
            <div class="time">{{ getTime(item.createTime) }}</div>
          </template>
          <template v-else>
            <div style="font-weight: bold">
              <span>{{ getTime(item.createTime) }}</span>
              <i class="el-icon-arrow-right" style="float: right" />
            </div>
          </template>
        </div>
        <p v-if="noMore" style="display: flex; justify-content: center">没有更多了</p>
      </div>
      <div v-else style="color: #9098a7; text-align: center">暂无数据</div>
    </el-card>
  </el-drawer>
</template>

<script>
import { adminMessageUpd, adminMessageList, adminMessageCount, adminMsgAllRead, getMessageCount } from '@/api/adminMessage'
import { getImgUrl } from '@/api/getFile'
import dayjs from 'dayjs'

export default {
  inject: ['indexThis'],
  data() {
    return {
      drawer: false,
      isMore: true,
      totalData: [],
      noMore: false,
      total: 0,
      page: {
        pageNo: 1,
        pageSize: 20,
      },
      readState: '1',
      show: false,
      readCount: 0,
      unreadCount: 0,
    }
  },
  methods: {
    handleClick(tab, event) {
      this.noMore = false
      this.readState = tab.name

      this.adminMessageList(true)
    },
    async adminMessageList(isEmpty) {
      this.noMore = false
      this.getMessageCount()
      if (isEmpty) {
        this.totalData = []
        this.page = {
          pageNo: 1,
          pageSize: 10,
        }
      }
      const { data: res } = await adminMessageList({ fromBackend: 1, staffId: this.$store.getters.staffId, ...this.page, readState: this.readState })
      const { data: total } = await adminMessageCount({ fromBackend: 1, staffId: this.$store.getters.staffId, ...this.page, readState: this.readState })
      this.total = total
      // this.$message.error('暂无更多数据')
      if (!res && !this.isMore) return (this.noMore = true)
      if (isEmpty) this.totalData = []
      res ? (this.totalData = [...this.totalData, ...res]) : (this.totalData = [...this.totalData])
      this.totalData.length > 0 ? (this.show = false) : (this.show = true)
      this.isMore = true
    },
    //获取已读跟未读数量
    async getMessageCount() {
      const { data: res } = await getMessageCount({})
      this.readCount = res.readCount
      this.unreadCount = res.unreadCount
    },
    // 触底加载
    loadMore() {
      if (this.total <= 10) return
      if (!this.isMore) return
      this.isMore = false
      this.page.pageNo++
      this.adminMessageList()
    },

    // 清楚未读
    async clearUnRead() {
      if (this.readState == 2) return
      if (!this.indexThis.adminMessageTotal) return this.$message.success('未读消息已清除')
      await adminMsgAllRead()
      this.$message.success('清除成功')
      this.adminMessageList(true)
      this.indexThis.myAdminMessageCount()
    },

    async goDetail(item) {
      if (item.readState === 1) {
        await adminMessageUpd({ id: item.id, readState: 2 })
        this.indexThis.myAdminMessageCount()
      }
      if (item.messageType) {
        let path = this.dictType('adminMessageEnumArr', item.messageType, 'path')
        if (item.messageType === 18 || item.messageType === 19 || item.messageType === 49 || item.messageType === 50)
          path = `${path}?applyOverviewId=${item.applyOverviewId}&messageType=${item.messageType}`

        const startIndex = path.indexOf('/') + 1 // 第一个斜杠的索引加 1
        const endIndex = path.indexOf('/', startIndex) // 第二个斜杠的索引
        let betweenSlashes
        if (startIndex !== -1 && endIndex !== -1) {
          betweenSlashes = path.substring(startIndex, endIndex)
        }
        this.$store.dispatch('permission/findIndexByPath', betweenSlashes)
        const accessRoutes = await this.$store.dispatch('permission/generateRoutes', this.routesCut)
        this.$router.addRoutes(accessRoutes)
        path === this.$route.fullPath
          ? this.$nextTick(() => {
              this.$router.replace({
                path: '/redirect' + this.$route.fullPath,
              })
            })
          : this.$router.push(path)
      }
      this.drawer = false
    },

    getImg(url) {
      if (!url) return
      return getImgUrl(url)
    },

    getTime(time) {
      if (!time) return '-'
      return dayjs(time).format('MM-DD HH:mm:ss')
    },

    sizeChange() {
      this.adminMessageList()
    },
    currentChange() {
      this.adminMessageList()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__nav-wrap::after {
  height: 0 !important;
}

::v-deep .el-tabs__item {
  height: 40px !important;
}

::v-deep .el-tabs__item.is-active {
  color: rgba(0, 0, 0, 0.9) !important;
  font-weight: bold;
}

::v-deep .el-tabs__active-bar {
  background-color: #31a8ff !important;
  width: 23px !important;
  height: 4px !important;
  left: 6px !important;
  border-radius: 23px !important;
}

::v-deep .el-card__body {
  padding-top: 8px !important;
}

.notice {
  font-size: 14px;
  color: #c1c1c1;
  padding: 34px 30px 16px 30px;
  border-bottom: 1px solid #ebebeb;
  cursor: pointer;

  .top {
    font-weight: bold;
    padding-bottom: 8px;
  }

  .time {
    font-size: 8px;
  }
}

.tip {
  padding: 8px 24px;
  background-color: #e8f3ff;
  color: #0e42d2;
  font-size: 14px;
}

.flexBte {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.unread {
  color: #1e1e1e;
  position: relative;
}

.unread::before {
  position: absolute;
  content: '';
  display: inline-block;
  width: 10px;
  height: 10px;
  left: 15px;
  top: 36px;
  background-color: #f53f3f;
  border-radius: 50%;
}

::v-deep .el-drawer__header {
  margin-bottom: 0px !important;
}

.readBox {
  width: 82px;
  height: 30px;
  border-radius: 4px;
  background: #31a8ff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer; //小手样式
  margin-right: 20px;
}

.readBoxHui {
  background-color: #f6f6f7 !important;
  color: #adacac !important;
}
</style>
